import { MetaShopOrderGetResponse } from "../api/front/meta/api-meta-shop-order";
import { MetaPrintShopOrderGetResponse } from "../api/sift/front/api-print-meta-shop-order";

type IsOneStop = 1 | 0 | boolean | null | undefined;
type IsOlc = 1 | 0 | boolean | null | undefined;
type IsOlcDelivery = 1 | 0 | boolean | null | undefined;

type NullableMetaShopOrderGetResponse = {
  [P in keyof MetaShopOrderGetResponse]: P extends 'isOneStop' ? IsOneStop
    : P extends 'isOneStopCancel' ? IsOneStop
    : P extends 'isOlc' ? IsOlc
    : P extends 'isOlcDelivery' ? IsOlcDelivery
    : MetaShopOrderGetResponse[P] | null;
}
/** ラボ発注が正常に完了しているかチェック機能 */
export class LaboOrderCompChecker {
  /**
   * 一定時間が経過しているかチェック
   * @param info ShopOrderMeta情報
   */
  static checkTimeOut(info: NullableMetaShopOrderGetResponse) {
    if (info.laboOrder?.isSuccess === 0) {
      return true;
    }
    const checkDate = (() => {
      if (info.isOneStop) {
        return info.oneStopOrderDate;
      }
      if (info.isOlc) {
        return info.laboOrder?.orderCompleteDate;
      }
      return info.laboOrder?.orderCompleteDate ?? info.orderDate;
    })();
      /* ミリ秒 -> 分に変換 */
    const m = 1000 * 60;
      /* 分 -> 時間に変換 */
    const h = m * 60;
    if (!checkDate) {
      if (info.isOlc) {
        return false
      };
      if (!info.orderDate) return true;
      const elapsedTime = Math.floor((Date.now() - (Date.parse(info.orderDate))));
      /* 完全にイレギュラーと判断する時間を指定 */
      const limit = 24 * h;
      return elapsedTime > limit;
    };
    const elapsedTime = Math.floor((Date.now() - (Date.parse(checkDate))))
    /* 不都合ありと判断する経過時間を指定 */
    const limit = 30 * m;
    return elapsedTime > limit;
  }

  static checkTimeoutForPrint(info: { orderCompleteDate: string }) {
    const checkDate = info.orderCompleteDate;
    if (!checkDate) return false;
    const elapsedTime = Math.floor((Date.now() - (Date.parse(checkDate))));
    /* ミリ秒 -> 分に変換 */
    const m = 1000 * 60;
    /* 不都合ありと判断する経過時間を何分にするか指定 */
    const limit = 30;
    return elapsedTime > m * limit;
  }
}
